import React from "react";
import { TbBellRinging, TbReceipt, TbDroplet, TbChefHat } from "react-icons/tb";
import "./RequestBadgeCluster.css";

// Fixed left-to-right stack order — last entry renders rightmost and on top.
export const REQUEST_CONFIG = {
  assistance: { color: "#FF9800", label: "Assistance", Icon: TbBellRinging },
  bill: { color: "#F44336", label: "Bill", Icon: TbReceipt },
  water: { color: "#2196F3", label: "Water", Icon: TbDroplet },
  "order-update": { color: "#4CAF50", label: "Order Update", Icon: TbChefHat },
};

export const STACK_ORDER = ["assistance", "bill", "water", "order-update"];

// Reusable stacked-icon indicator for pending table requests. Purely visual —
// drop into any table card as an absolutely-positioned sibling (it positions
// itself at the card's top-right corner). No click interaction; resolving a
// request happens elsewhere (navbar notification panel / waiter view).
const RequestBadgeCluster = ({ requests = [] }) => {
  const ordered = STACK_ORDER?.map((type) => requests?.find((r) => r.type === type))?.filter(Boolean);

  if (!ordered?.length) return null;

  return (
    <div
      className="rbc-trigger"
      title={`${ordered?.length} active request${ordered?.length > 1 ? "s" : ""}`}
    >
      {ordered.map((req, index) => {
        const cfg = REQUEST_CONFIG[req?.type];
        return (
          <span
            key={req.type}
            className="rbc-icon"
            style={{
              backgroundColor: cfg.color,
              zIndex: index + 1,
              marginRight: index === ordered?.length - 1 ? 0 : -6,
            }}
          >
            <cfg.Icon size={12} color="#ffffff" />
          </span>
        );
      })}
    </div>
  );
};

export default RequestBadgeCluster;
